import { UserRecordSelfLayout } from "@/components/user-record/user-record-self-layout";
import { useUserRecordsV2 } from "@/lib/hooks/use-user-records-v2";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile")({
  component: ProfileLayout,
});

function ProfileLayout() {
  const enabled = useUserRecordsV2();

  if (!enabled) {
    return <Navigate to="/settings" />;
  }

  return <UserRecordSelfLayout />;
}
